import { useSnackbar } from 'notistack';
import { useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import { SeoPage } from '../../../@types/seoPage';

export const useSeoPages = () => {
  const [seoPages, setSeoPages] = useState<SeoPage[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [currentSeoPage, setCurrentSeoPage] = useState<SeoPage | undefined>();
  const [filteredData, setFilteredData] = useState<SeoPage[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const getSeoPageList = async () => {
    const response = await axiosInstance.get(APIS.SEO_PAGES.LIST);
    setSeoPages(response.data.data);
    setFilteredData(response.data.data);
  };

  const filterResult = (name: string) =>
    seoPages.filter((seoPage) => seoPage.title.toLowerCase().includes(name.toLowerCase()));

  const handleFilterName = (filter: string) => {
    setFilterName(filter);

    setFilteredData(filterResult(filter));
  };

  const handleEditRow = (selected: SeoPage) => {
    setCurrentSeoPage(selected);
    setModalOpen(true);
  };
  const handleDeleteRow = async (id: string) => {
    try {
      await axiosInstance.delete(APIS.SEO_PAGES.DELETE(id));
      enqueueSnackbar('Deleted Successfully', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.message || 'Deleted Successfully', { variant: 'error' });
    }
    setConfirmationOpen(true);
  };

  return {
    modalOpen,
    setModalOpen,
    confirmationOpen,
    setConfirmationOpen,
    filterName,
    filterRole,
    currentSeoPage,
    setCurrentSeoPage,
    filteredData,
    handleDeleteRow,
    handleEditRow,
    handleFilterName,
    getSeoPageList,
  };
};
